import { useState, useCallback, useRef, useEffect } from 'react';
import { TITLE_BY_PATHNAME } from 'constants/titleByPathname';
/* eslint-disable-next-line import/prefer-default-export */
export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};


export const useMouseDelta = (initialWidth) => {
  const [result, setResult] = useState(initialWidth);
  const dragging = useRef(false);
  const draggingIcon = useRef();
  const previousClientX = useRef(0);

  const handleMouseMove = useCallback((e) => {
    if (!dragging.current) {
      return;
    }

    setResult((preResult) => {
      const change = e.x - previousClientX.current;
      previousClientX.current = e.x;
      return preResult - (change * 2);
    });
  }, []);

  const handleMouseDown = useCallback((e) => {
    previousClientX.current = e.x;
    dragging.current = true;
  }, []);

  const handleMouseUp = useCallback(() => {
    dragging.current = false;
  }, []);

  useEffect(() => {
    draggingIcon.current.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      draggingIcon.current.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseDown, handleMouseUp, handleMouseMove]);

  return [result, draggingIcon];
};


export const useOutsideClick = (cb, dep) => {
  const ref = useRef(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleClickOutside = useCallback(cb || (() => {}), dep);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClickOutside(event);
      }
    };

    document.addEventListener('mousedown', onClickOutside);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, [ref, handleClickOutside]);

  return ref;
};

export const changeDocumentTitle = (title) => {
  if (title === null) return;
  const defaultDocumentTitle = 'PR Volt';
  const newDocumentTitle = title ? `${title} | ${defaultDocumentTitle}` : defaultDocumentTitle;
  document.title = newDocumentTitle;
};
export const useDocumentTitle = (title) => {
  useEffect(() => {
    changeDocumentTitle(title);
  }, [title]);
};

export const useDocumentTitleObserveRouting = pathname => useDocumentTitle(TITLE_BY_PATHNAME[pathname]);
